export class TwoFactorModel {

  public code: string;
  public rememberDevice: boolean;
  public deviceToken: string;
}
